import { useMutation, useQueryClient } from '@tanstack/react-query'
import { adminApi, UpdateMemberProfileRequest } from 'services/adminApi'

export const useUpdateMemberProfile = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      companyId,
      userId,
      data,
    }: {
      companyId: string
      userId: string
      data: UpdateMemberProfileRequest
    }) => adminApi.updateMemberProfile(companyId, userId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['company', 'members'] })
      queryClient.invalidateQueries({ queryKey: ['companyUsers'] })
    },
  })
}
